import { createApp } from 'vue';
import AdvancedHotspots from 'Vue/containers/AdvancedHotspots.vue';

namespace Worthington.advancedHotspots {

	// @ts-ignore
	let module:any = {};

	export const init = () => {
		const elements = document.querySelectorAll('.js-advanced-hotspots');
		if (elements.length) {
			elements.forEach((element) => {
				const ah = createApp(AdvancedHotspots);
				ah.mount(element);
			});

		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	Worthington.advancedHotspots.init();
});
